/**
 * Strips query strings and fragments from the page URLs Datadog attaches to every event.
 *
 * Redirect sign-ins land on the page with `?token=` or `?code=` in the URL, and the Datadog SDKs
 * copy `window.location.href` and `document.referrer` into `view.url` and `view.referrer`.
 * Use as `beforeSend` in both `datadogLogs.init` and `datadogRum.init`.
 */

export const withoutQuery = (url) => (typeof url === 'string' ? url.split(/[?#]/)[0] : url)

/**
 * @param {{ view?: { url?: string, referrer?: string } }} event - a log or RUM event
 * @returns {boolean} always true: the event is kept
 */
export const stripViewQuery = (event) => {
  if (event && event.view) {
    event.view.url = withoutQuery(event.view.url)
    event.view.referrer = withoutQuery(event.view.referrer)
  }
  return true
}
